const AGE_GROUP_NAME = /\b(faixa\s*etaria|idade|publico)\b/
const GENDER_NAME = /\b(generos?|sexo)\b/

const AGE_GROUP_TERMS = {
  adult: ['adulto', 'adultos', 'adult'],
  kids: ['infantil', 'infantis', 'crianca', 'criancas', 'kids', 'juvenil'],
  both: ['ambos', 'todos']
}

const GENDER_TERMS = {
  male: ['masculino', 'masculina', 'homem', 'male'],
  female: ['feminino', 'feminina', 'mulher', 'female'],
  unisex: ['unissex', 'unisex', 'ambos']
}

const AGE_GROUP_LABELS = { adult: 'Adulto', kids: 'Infantil', both: 'Ambos' }
const GENDER_LABELS = { male: 'Masculino', female: 'Feminino', unisex: 'Unissex' }

export const normalize = text => String(text)
  .normalize('NFD')
  .replace(/[̀-ͯ]/g, '')
  .toLowerCase()
  .trim()

/**
 * Retorna a opção cujo texto casa com os termos do valor do hub.
 * Prioriza igualdade e, na falta dela, aceita opções que contenham o termo.
 */
export const matchValue = (values, hubValue, termsMap) => {
  const terms = termsMap[hubValue]

  if (!terms || !Array.isArray(values)) {
    return undefined
  }

  const options = values.map(value => ({ value, normalized: normalize(value) }))

  for (const term of terms) {
    const exact = options.find(option => option.normalized === term)

    if (exact) {
      return exact.value
    }
  }

  for (const term of terms) {
    const partial = options.find(option => option.normalized.includes(term))

    if (partial) {
      return partial.value
    }
  }

  return undefined
}

/**
 * Retorna o gênero e a faixa etária do produto para pré-selecionar atributos do marketplace.
 * O gênero é por variação, então usa a primeira variação selecionada (ou a primeira da lista).
 */
export const getProductCharacteristics = product => {
  const variations = product.variations || []
  const variation = variations.find(variation => variation.selected) || variations[0]

  return {
    ageGroup: product.ageGroup,
    gender: variation ? variation.gender : undefined
  }
}

/**
 * Retorna a opção do atributo do marketplace que corresponde à faixa etária ou ao gênero do produto.
 * Independe do formato do marketplace: recebe só o nome do atributo e os textos das opções.
 * Retorna undefined quando o atributo não é de faixa etária/gênero ou não há opção equivalente.
 */
export const findCharacteristicValue = (attributeName, values, { ageGroup, gender }) => {
  const name = normalize(attributeName)

  if (ageGroup && AGE_GROUP_NAME.test(name)) {
    return matchValue(values, ageGroup, AGE_GROUP_TERMS)
  }

  if (gender && GENDER_NAME.test(name)) {
    return matchValue(values, gender, GENDER_TERMS)
  }

  return undefined
}

/**
 * Retorna o rótulo padrão (PT) da faixa etária ou do gênero do produto para campos de texto livre,
 * quando o nome do atributo é de faixa etária/gênero. Retorna undefined nos demais casos.
 */
export const getCharacteristicLabel = (attributeName, { ageGroup, gender }) => {
  const name = normalize(attributeName)

  if (ageGroup && AGE_GROUP_NAME.test(name)) {
    return AGE_GROUP_LABELS[ageGroup]
  }

  if (gender && GENDER_NAME.test(name)) {
    return GENDER_LABELS[gender]
  }

  return undefined
}



// WEBPACK FOOTER //
// ./src/components/marketplace/shared/provide/presetCharacteristics.js